/** Refactor routing ok  */
import { RouteName } from "../RouteNames";

export const JORFRoutes = {
  name: RouteName.JORFRoot,
  path: "jorfs",

  children: [
    {
      name: RouteName.JORF,
      path: "",
      component: () => import("@follaw-fr/views/side_menu_views/JorfsView.vue"),
    },
    {
      name: RouteName.JORFFollawed,
      path: "follawed",
      component: () => import("@follaw-fr/views/side_menu_views/JorfsView.vue"),
    },
    {
      name: RouteName.JORFZoom,
      path: ":_id",
      component: () =>
        import("@follaw-fr/views/side_menu_views/JorfZoomView.vue"),
    },
  ],
};
